import { Component, OnInit, HostListener, HostBinding } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from '../../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../services/language.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-cyclist-portal',
  templateUrl: './cyclist-portal.component.html',
  styleUrls: ['./cyclist-portal.component.scss'],
  providers: [MessageService],
})
export class CyclistPortalComponent implements OnInit {
  public menuOpen = true;
  public dropMenuOpen = false;
  public userName: string = '';
  public profile: any = {};
  public menuItems: any = [];
  public adminMenuItems: any = [];
  public showShadow: boolean = false;
  public platform = '';
  public customCSSURL = null;
  public loadingTheme = false;
  public showNavBar = true;
  public partnerId: any;


  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public router: Router,
    public route: ActivatedRoute,
    public messageService: MessageService,
    public partnerService: PartnerService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }


  loadScript(url) {
  let node = document.createElement('script');
  node.src = url; 
  node.type = 'text/javascript'; 
  node.async = true;
  node.charset = 'utf-8';
  document.getElementsByTagName('head')[0].appendChild(node); 
}

  async ngOnInit() {
    this.platform =
      navigator.platform.indexOf('iPhone') > -1
        ? 'iOS'
        : navigator.platform.indexOf('Android') > -1 ||
          navigator.platform.indexOf('Linux') > -1
          ? 'Android'
          : 'Other';

    this.route.queryParams.subscribe((params) => {
      if (params['Theme']) {
        this.loadingTheme = true;
        this.customCSSURL = this.transform(params['Theme']);
      }
    });

    console.log('theme');
    console.log(this.customCSSURL);

    let currentRoute = this.route;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    const params = await firstValueFrom(currentRoute.paramMap);
    this.partnerId = params.get('partnerid')!;
    console.log('Partner ID:', this.partnerId);

    if(this.partnerId) {
      this.partnerService
        .getPartnerType(this.partnerId)
        .subscribe((result) => {


          if (this.appConfig.isDev() || result.statusID == 51)
            this.loadScript('https://sandbox.web.squarecdn.com/v1/square.js');
          else
            this.loadScript('https://web.squarecdn.com/v1/square.js');

          // Get browser language or fallback
          const browserLanguage = this.languageService.getTranslationFile().replace('.json', '');

          var getShopBrowserLanguage = this.appConfig.getPartnerType(result.partnerType) === 'bicycle'
            ? browserLanguage
            : this.appConfig.getPartnerType(result.partnerType) + '/' + browserLanguage;
          console.log('Shop language: ', getShopBrowserLanguage);

          this.translate.setDefaultLang(getShopBrowserLanguage);
          this.translate.get('hubtiger').subscribe((res) => {
            console.log('Language loaded');
          });
        });
    }

    // // Set the default language in TranslateService
    // this.translate.setDefaultLang(browserLanguage);

    // // Optionally, initialize the translation language
    // this.translate.use(browserLanguage);

    if (this.router.url.indexOf('/cyclist/manufacturer-bike') > -1) {
      this.showNavBar = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;

    if (pos == max) {
      this.showShadow = false;
    } else {
      this.showShadow = true;
    }
  }

  transform(ID) {
    var env = this.appConfig.getEnvironmentNew();
    setTimeout(() => {
      this.loadingTheme = false;
    }, 1000);

    return this.sanitizer.bypassSecurityTrustResourceUrl(
      env.url + `/Portal/CustomCSS/${ID}?code=${env.key}`,
    );
  }
}
